module.exports = __webpack_public_path__ + "img/i_my_menu_kakao.0275c760.svg";